<template>
  <el-form size="small" label-width="90px">
    <el-form-item label="选择标签">
      <el-select v-model="selectTag">
        <el-option v-for="item in tagList" :key="item.id" :value="item.id" :label="item.title"></el-option>
      </el-select>
    </el-form-item>
    <div style="margin-top:20px;text-align:center">
      <el-button size="small" @click="submit()" type="primary">保存</el-button>
      <el-button size="small" @click="close(0)">取消</el-button>
    </div>
  </el-form>
</template>

<script>
import { listCommonTag,setUserTag } from "@/api/market";
import { mapGetters } from "vuex";

export default {
  props:{
    uid: {
      type: String,
      default: ""
    }
  },
  data(){
    return{
      selectTag: "",
      tagList: []
    }
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  mounted(){
    this.init();
  },
  methods:{
    init(){
      var data = {
        token: this.token,
        app_id: this.app_id
      }
      listCommonTag(data).then(res => {
        if (res.code == 200) {
          this.tagList = res.data;
        } else {
          this.$message.waring(res.msg);
        }
        console.log("手动标签列表", res);
      });
    },
    submit(){
      var data = {
        token: this.token,
        app_id: this.app_id,
        uid: this.uid,
        tag_id: this.selectTag
      }
      setUserTag(data).then(res => {
        if(res.code == 200){
          this.$message.success('保存成功')
          this.close(1)
        }
      })
    },
    close(i){
      this.$emit('closeTag',i)
    }
  }
}
</script>